import { render, staticRenderFns } from "./ReceptionsForDelivery.vue?vue&type=template&id=311e406c"
import script from "./ReceptionsForDelivery.vue?vue&type=script&lang=js"
export * from "./ReceptionsForDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports